module.exports = __webpack_public_path__ + "c5fd001061c649376f8b223f5a751143.png";